import type { TimeSlotCardTimeSlotFragment } from '@/components/organisms/TimeSlotPickerModal/TimeSlotCard.generated'
import type { Ref } from 'vue'
import { sortBy } from 'lodash-es'

export type TimeSlot = Pick<TimeSlotCardTimeSlotFragment, 'startsAt' | 'endsAt'>

export type PickedTimeSlots = TimeSlot[] & { __PickedTimeSlotsBrand: never }
export const empty = () => [] as TimeSlot[] as PickedTimeSlots

const equals = (a: TimeSlot, b: TimeSlot) =>
  a.startsAt == b.startsAt && a.endsAt == b.endsAt

export const useTimeSlot = (pickedTimeSlots: Ref<PickedTimeSlots>) => {
  const isPicked = (timeSlot: TimeSlot) =>
    pickedTimeSlots.value.some(elm => equals(elm, timeSlot))

  const togglePicked = (timeSlot: TimeSlot) => {
    const newTimeSlots = (() => {
      if (isPicked(timeSlot)) {
        return pickedTimeSlots.value.filter(picked => !equals(picked, timeSlot))
      }
      return [...pickedTimeSlots.value, timeSlot]
    })()

    return sortBy(newTimeSlots, 'startsAt')
  }

  return { isPicked, togglePicked }
}
